import { DateTime } from 'luxon';

export const normaliseDateToMonthYear = (dateStr: string): DateTime | null => {
  if (!dateStr) {
    return null;
  }

  // Return value early if the dateStr is already correctly formatted
  const formattedDate = DateTime.fromFormat(dateStr, 'MM/yyyy');

  if (formattedDate.isValid) {
    return formattedDate;
  }

  // These known formats were taken from a DB dump of 500 patient `medicare_exp_date` values
  const knownFormats = ['yyyy/MM', 'yyyy/MM/dd', 'dd/MM/yyyy', 'dd-MM-yyyy', 'yyyy-MM-dd', 'M/yy', 'MM/yy'];

  // Match any of the known formats and if there is a match then return the MM/YYYY format
  for (const knownFormat of knownFormats) {
    const date = DateTime.fromFormat(dateStr, knownFormat);
    if (date.isValid) {
      return date;
    }
  }

  return null;
};
